/// <reference path="../types.d.ts" />
import { commonEnums, HttpMethods } from '@codametrix/ui-common';
import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import { getDefaultOrg, getDefaultServiceLine, getHomepagePreference } from '../core/preferences/preferences';
import { saveFormData } from './account-settings';
import { UserPreferences } from './action-types';
import { showFeedbackWarning, setHomepagePreference } from './ui';
const { UserPreferenceSection } = commonEnums;
const deletePreferenceValues = createAsyncThunk(UserPreferences.DELETE_PREFERENCE_VALUE, async (payload, { dispatch, getState, rejectWithValue })=>{
    await api({
        endpoint: `/userpreferences/${payload.userId}/${payload.keyname}/v1`,
        init: {
            method: HttpMethods.DELETE
        }
    });
});
const saveUserPreference = createAsyncThunk(UserPreferences.SAVE_PREFERENCE, async (payload, { dispatch, getState, rejectWithValue })=>{
    const preferences = await api({
        endpoint: `/userpreferences/${payload.userId}/v1`,
        init: {
            method: HttpMethods.GET
        }
    });
    if (preferences?.filter((p)=>p.keyname === payload.keyname).length > 0) {
        await dispatch(deletePreferenceValues(payload));
    }
    const body = {
        section: UserPreferenceSection.USER_PREFERENCE,
        keyname: payload.keyname,
        ownerId: payload.userId,
        values: [
            {
                value: payload.value,
                tenantId: payload.tenantId ?? null,
                preferenceId: null,
                version: null,
                id: null
            }
        ]
    };
    await api({
        endpoint: `/userpreferences/v1`,
        init: {
            method: HttpMethods.POST
        },
        body: body
    }).catch((e)=>{
        dispatch(showFeedbackWarning({
            id: Date.now(),
            message: `Unable to save preference`,
            dismissable: true
        }));
    });
    dispatch(loadPreferences(payload.userId));
    return;
});
const loadPreferences = createAsyncThunk(UserPreferences.LOAD_USER_PREFERENCES, async (userId, { dispatch, getState, rejectWithValue })=>{
    const userDefaults = await api({
        endpoint: `/userpreferences/${userId}/v1`
    });
    const defaultOrgId = getDefaultOrg(userDefaults);
    const defaultServiceLine = getDefaultServiceLine(userDefaults);
    const homepagePreference = getHomepagePreference(userDefaults);
    dispatch(setHomepagePreference(homepagePreference));
    const shellHomepage = {
        path: '',
        tenantId: ''
    };
    dispatch(saveFormData({
        defaultOrg: defaultOrgId,
        defaultServiceLine,
        defaultHomepage: shellHomepage
    }));
});
const updatePreferenceValues = createAsyncThunk(UserPreferences.UPDATE_PREFERENCE_VALUE, async (payload, { dispatch, getState, rejectWithValue })=>{
    const body = {
        id: null,
        preferenceId: null,
        tenantId: payload.preferenceValue.tenantId,
        value: payload.preferenceValue.value,
        version: null
    };
    await api({
        endpoint: `/userpreferences/${payload.userId}/${payload.keyname}/v1`,
        init: {
            method: HttpMethods.PUT
        },
        body
    });
    dispatch(loadPreferences(payload.userId));
});
export { saveUserPreference, deletePreferenceValues, loadPreferences, updatePreferenceValues };
